import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { notificationError } from "./notification";

export async function getPermission(accessLevel: string){
    const params = {
        permission: accessLevel
    }
    let res = ''
    await Api.get(endpoints.getPermission, {params}).then((response) => {
      if(response.status === 200 && response.data) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              res = response.data
          }
      }
    }).catch((err: string) => {
      notificationError('Could not get access level')
    })
    
    return res  
}

export async function getAllowCreateNewDevicePermission(){
    let res = {return: false}
    await Api.get(endpoints.getAllowCreateNewDevicePermission).then((response) => {
      if(response.status === 200 && response.data) {
        if(response.data.error) {
            notificationError(`${response.data.message}`)
        } else {
            res = response.data
        }
      }
    }).catch((err: string) => {
      notificationError('Could not get access permission to create device')
    })
    
    return res  
}
